import React, { useContext } from 'react';
import { BodyText } from '@paypalcorp/pp-react';
import styles from '../TestCards.module.less';
import CopyToClipboard from '../../../../components/CopyToClipboard';
import IntegrationPageSectionContext from '../../StateManagement/IntegrationPageSectionContext';

const Non3DsTestCards = () => {
  const { Non3DsCards = {} } = useContext(IntegrationPageSectionContext);

  return (
    <BodyText as="div">
      <div className={styles.test_cards_section}>
        {Non3DsCards.cards
          ? Non3DsCards.cards.map((card) => (
              <div className={styles.card} key={card.number}>
                <span className={styles.card_brand}>{card.brand}</span>
                <span className={styles.card_number}>{card.number}</span>
                <CopyToClipboard contentToCopy={card.number} />
              </div>
            ))
          : null}
        {Non3DsCards && Non3DsCards.additionaltestcardslink && (
          <div className={styles.view_all}>
            <a href={Non3DsCards.additionaltestcardslink} rel="noreferrer">
              View all test cards
            </a>
          </div>
        )}
      </div>
    </BodyText>
  );
};

export default Non3DsTestCards;
